import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=52054a80&scoped=true&"
import script from "./editDialog.vue?vue&type=script&lang=js&"
export * from "./editDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52054a80",
  null
  
)

export default component.exports